<template>
  <v-container>
    <v-card class="mx-auto mt-5" max-width="800">
      <v-card-title class="headline">
        {{ $t('Auswertung - Azubi Liste') }}
      </v-card-title>
      <v-card-subtitle v-if="course">
        {{ $t('Kurs') }}: {{ course.name }}
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-list v-if="users && users.length > 0">
        <v-list-item
          v-for="user in users"
          :key="user.id"
          @click="selectUser(user)"
          link
        >
          <v-list-item-header>
            <v-list-item-title>{{ user.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
          </v-list-item-header>
          <template v-slot:append>
            <div class="d-flex align-center">
              <v-icon>mdi-chevron-right</v-icon>
            </div>
          </template>
        </v-list-item>
      </v-list>
      <v-card-text v-else-if="loading" class="text-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-card-text>
      <v-card-text v-else class="text-center">
        {{ $t('Keine Azubis gefunden.') }}
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getMesskursVisibleUsers } from '@/services/messkursVisibleUsers';

export default {
  name: 'EvaluationListView',
  setup() {
    const store = useStore();
    const router = useRouter();
    const users = ref([]);
    const loading = ref(false);

    const course = computed(() => store.state.course);

    const fetchUsers = async () => {
      if (course.value && (course.value.id || course.value._id)) {
        loading.value = true;
        try {
          const courseId = course.value.id || course.value._id;
          const managerUserId = store.state.user?.id || store.state.user?._id;
          users.value = await getMesskursVisibleUsers(managerUserId, courseId);
        } catch (error) {
          console.error("Error fetching evaluation users:", error);
          users.value = [];
        } finally {
          loading.value = false;
        }
      } else {
        // If no course in store, redirect back to course selection
        console.warn("No course found in store for evaluation. Redirecting to course selection.");
        router.push({ name: 'EvaluationCourseSelection' });
      }
    };

    // Watch for course changes to re-fetch users if needed (e.g. after default course is loaded)
    watch(() => course.value, (newCourse) => {
      if (newCourse && users.value.length === 0 && !loading.value) {
        fetchUsers();
      }
    });

    const selectUser = (user) => {
      router.push({ name: 'EvaluationUserTests', params: { userId: user.id } });
    };

    onMounted(() => {
      fetchUsers();
    });

    return {
      users,
      loading,
      course,
      selectUser
    };
  }
};
</script>
